// extracted by mini-css-extract-plugin
export default {"container":"NQ1a47aPyjoB0MvzEQPqqg=="};